module.exports = __webpack_public_path__ + "img/title2.4d6eef3d.png";